import{useChatState as t}from"./use-chat-state.hook.js";const o=()=>{const o=t(),{userId:r}=o;return r};export{o as useChatCurrentUser};